import React from 'react';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import DefaultPopoverContent from '../../_partials/DefaultPopoverContent';
import PopperPositionedPopover from '../../PopperPositionedPopover';
/** Use when you just need to stick a thing next to another thing
 *  Please note that this component is not DS-conforming */ const SimplePopperPopover = ({ children , popoverContent , usePortal , className , wrapperClassName , contentClassName , arrowClassName , portalClassName , showArrow , forceTheme , width , height , isVisible , placement , secondaryPlacement , offsetModifier , allowFlip , positionFixed , eventsEnabled , referenceElement , onClickOutside , onMouseLeave ,  })=>{
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        isVisible: isVisible,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        offsetModifier: offsetModifier,
        allowFlip: allowFlip,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        referenceElement: referenceElement,
        renderPopover: ({ effectivePlacement , effectiveSecondaryPlacement , rootRef , arrowRef , arrowStyle , contentStyle , arrowAttributes , contentAttributes , updatePositioning ,  })=>{
            const content = /*#__PURE__*/ React.createElement(DefaultPopoverContent, {
                effectivePlacement: effectivePlacement,
                effectiveSecondaryPlacement: effectiveSecondaryPlacement,
                rootRef: rootRef,
                arrowRef: arrowRef,
                contentStyle: contentStyle,
                arrowStyle: arrowStyle,
                contentAttributes: contentAttributes,
                arrowAttributes: arrowAttributes,
                updatePositioning: updatePositioning,
                showArrow: showArrow,
                contentClassName: contentClassName,
                arrowClassName: arrowClassName,
                wrapperClassName: wrapperClassName,
                width: width,
                height: height,
                onClickOutside: onClickOutside,
                onMouseLeave: onMouseLeave
            }, typeof popoverContent === 'function' ? popoverContent({
                placement: effectivePlacement,
                updatePositioning
            }) : popoverContent);
            return forceTheme ? /*#__PURE__*/ React.createElement(ThemeOverride, {
                theme: forceTheme
            }, content) : content;
        },
        usePortal: usePortal,
        className: className,
        portalClassName: portalClassName
    }, children);
};
SimplePopperPopover.displayName = 'SimplePopperPopover';
export default SimplePopperPopover;
